<template>
  <div class="col-xxl-11 col-md-12 box-col-11 col-12 ms-xxl-5">
    <div class="card">
      <div class="card-header">
        <div class="transaction-value">Transactions value by month</div>
      </div>
      <div class="card-body">
        <div class="chart-container column-container">
          <apexchart
            height="350"
            type="bar"
            :options="chartOptions"
            :series="chartSeries"
          ></apexchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useOverviewStore } from '@/store/driver/overview';

const primary = '#00c962';

const chartOptions = {
  chart: {
    height: 350,
    type: 'bar',
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  legend: {
    show: false,
  },
  colors: [primary],
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      borderRadius: 0,
      horizontal: false,
      columnWidth: '25%', // 調整柱形的寬度
      endingShape: 'flat',
    },
  },
  stroke: {
    show: true,
    colors: ['transparent'],
  },
  title: {
    text: '',
    align: 'left',
    style: {
      fontSize: '12px',
    },
  },
  subtitle: {
    text: '',
    floating: true,
    align: 'right',
    offsetY: 0,
    style: {
      fontSize: '22px',
    },
  },
  xaxis: {
    categories: [], // 會在下面動態生成
    labels: {
      style: {
        fontSize: '14px',
      },
    },
  },
  yaxis: {
    tickAmount: 7, // 顯示7個刻度
    max: 700, // 最大值設為700
    min: 0,   // 最小值設為0
    labels: {
      style: {
        fontSize: '14px',
        color: '#333',
      },
      formatter: function (val) {
        return '$' + val.toFixed(0);
      },
    },
  },
  grid: {
    borderColor: '#e0e0e0',
    strokeDashArray: 5,
  },
  fill: {
    colors: [primary],
  },
  tooltip: {
    y: {
      formatter(val) {
        return '$ ' + val.toFixed(2); // 调整格式化样式
      },
    },
    custom: function({ series, seriesIndex, dataPointIndex, w }) {
      const value = series[seriesIndex][dataPointIndex];
      return `<div class="arrow_box p-2">
                  <span>$${value.toFixed(2)}</span>
              </div>`;
    }
  },
};

// 引入store
const { overviewInfo } = useOverviewStore();

// 根據當前月份動態計算顯示順序
const currentMonth = new Date().getMonth() + 1; // JavaScript 中月份是從 0 開始的，所以需要 +1
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const dynamicMonths = [];

for (let i = 0; i < 12; i++) {
  const monthIndex = (currentMonth - 1 - i + 12) % 12;
  dynamicMonths.unshift(months[monthIndex]); // 從最右邊開始推
}

chartOptions.xaxis.categories = dynamicMonths;

// 計算並更新chartSeries
const chartSeries = computed(() => {
  const data = Array(12).fill(0); // 初始化12個月份的數據
  const monthFaceValue = overviewInfo.month_face_value;

  // 按照動態月份順序排列數據
  for (let i = 0; i < 12; i++) {
    const month = (currentMonth - i + 12) % 12 || 12; // 獲取對應的月份索引
    data[11 - i] = monthFaceValue[month] || 0;
  }

  return [{ data }];
});
</script>

<style scoped>
.chart-container {
  padding: 20px;
}

.transaction-value{
  font-family: Euclid Square;
  font-size: 24px;
  font-weight: 500;
  line-height: 30.43px;
  text-align: left;
  margin-bottom: 20px;
  margin-top: 10px;
}
</style>